import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './logout.content.json';

/**
 * @ngdoc component
 * @name LogoutComponent
 * @module LogoutModule
 */
@Component({
    selector: 'tokens-browser-logout',
    templateUrl: 'logout.component.html',
    standalone: false
})
export class LogoutComponent implements OnInit {
    @Output()
    public registerBrowser: EventEmitter<void> = new EventEmitter();

    @Output()
    public cancel: EventEmitter<void> = new EventEmitter();

    public constructor(private readonly contentService: ApContentService) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public onRegisterBrowser(): void {
        this.registerBrowser.emit();
    }

    public onCancel(): void {
        this.cancel.emit();
    }
}
